var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCloseLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758240595897,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 103226,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 128V42.666667h-85.333333v85.333333H128a42.666667 42.666667 0 0 0-42.666667 42.666667v682.666666a42.666667 42.666667 0 0 0 42.666667 42.666667h768a42.666667 42.666667 0 0 0 42.666667-42.666667V170.666667a42.666667 42.666667 0 0 0-42.666667-42.666667h-170.666667V42.666667h-85.333333v85.333333H384zM170.666667 426.666667h682.666666v384H170.666667V426.666667z m0-213.333334h128v42.666667h85.333333v-42.666667h256v42.666667h85.333333v-42.666667h128v128H170.666667v-128z m250.816 254.485334L512 558.336l90.496-90.517333 60.352 60.330666L572.330667 618.666667l90.517333 90.496-60.330667 60.352L512 679.018667l-90.517333 90.496-60.330667-60.352L451.626667 618.666667l-90.496-90.517334 60.330666-60.330666z",
    "p-id": 103227,
    fill: "#ef4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCloseLine);
export default __webpack_public_path__ + "static/media/calendar-close-line.7fdbf7e1.svg";
export { ForwardRef as ReactComponent };